import { Filter } from '@anytag/shared-molecules';
import { useTiktokInfluencersContext } from '../TiktokInfluencersContext';
import { BasicFilter } from './BasicFilter';

export const TiktokInfluencersFilter = () => {
  const { filter, setFilter, isTtcmCampaign, isEngagementPage, isPackagePage } = useTiktokInfluencersContext();

  return (
    <Filter.Provider onSubmit={setFilter} values={filter} className="rounded-none">
      <BasicFilter isEngagementPage={isEngagementPage} isTtcmCampaign={isTtcmCampaign} isPackagePage={isPackagePage} />
    </Filter.Provider>
  );
};
